import { Link } from '@tanstack/react-router'
import { SITE_IMAGES } from '@/lib/site-images'

export function SiteHeader() {
  return (
    <header className="marketing-header border-bottom border-secondary border-opacity-25">
      <nav className="navbar navbar-expand-md bg-body-secondary py-3">
        <div className="container">
          <Link to="/" className="navbar-brand d-flex align-items-center py-0">
            <img src={SITE_IMAGES.logo} alt="Halo Compliance" className="marketing-logo" height={40} />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#marketingNav"
            aria-controls="marketingNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="marketingNav">
            <ul className="navbar-nav ms-auto mb-2 mb-md-0 gap-md-2 align-items-md-center">
              <li className="nav-item">
                <Link to="/product" className="nav-link" activeProps={{ className: 'nav-link active' }}>
                  Product
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/about" className="nav-link" activeProps={{ className: 'nav-link active' }}>
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link" activeProps={{ className: 'nav-link active' }}>
                  Contact
                </Link>
              </li>
              <li className="nav-item ms-md-2">
                <Link to="/contact" className="btn btn-primary btn-sm px-3 mt-2 mt-md-0">
                  Schedule a Demo
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  )
}
